import "./InboundFlow.css";
import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { DataGrid, useGridApiRef} from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import { faCircleXmark, faEllipsis, faThumbtack, faPhoneSlash, faRotateLeft, faPhone, faFileExport} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { useDispatch } from "react-redux";
import { login, logout } from "../../features/userSlice";
import { v4 as uuidv4 } from 'uuid';
import { useContextStateManagement } from "../../context/ContextApi";
import { getUserLicenseDetails } from "../../Variables";
import { useNavigate } from "react-router-dom";
import { usePracticeTimezone } from "../../hooks/usePracticeTimezone";
import { formatUsDateInPracticeTimezone } from "../../practiceTimezone";

export const ChatGGrid = ({ setIsCallsDataGet, setIsUploadLead, setChatGGridData, chatGGridData, providerName, patientName, startDate, endDate, isUploadLead, setOutBoundLeadsDetail }) => {
  const [modalShow, setModalShow] = useState(false)
  const [activeModal, setActiveModal] = useState();
  const [userId, setUserId] = useState();
  const [menuId, setMenuId] = useState();
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [transcriptRecord, setTranscriptRecord] = useState("");
  const [summary, setSummary] = useState("");
  const [status, setStatus] = useState("");
  const [isData, setIsData] = useState(false);
  const [callAPIMsg, setCallAPIMsg] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setActiveTab, PracticeId, token, outBoundContact, usersPostRequest, fetchUserRecord, setSideBarLinkActive, setToken, dateRangeRequest, userType, setUserType, deleteRequest, practiceContactNumber } = useContextStateManagement();
  const practiceTimezone = usePracticeTimezone(PracticeId, token);

  const columns = [
    // {
    //   field: "thumbtackIcon",
    //   headerName: "Pin",
    //   width: 50,
    //   renderCell: () => <FontAwesomeIcon icon={faThumbtack} />,
    // },
    { field: "Status", headerName: "Status", width: 150, renderCell: (params) => <Tooltip title="View Status"> <button className="transcript_button" onClick={() => statusHandle(params.row.Id)} >Click to view status</button> </Tooltip> },
    {
      field: "CreateDateTime", headerName: "Created Date", width: 160,
      renderCell: (params) =>
        formatUsDateInPracticeTimezone(params.value, practiceTimezone),
    },
    // {
    //   field: "CallDetails",
    //   headerName: "Call Details",
    //   width: 100,
    //   renderCell: (params) => (
    //     <div className="text-center position-relative userImageCallDiv">
    //       <div className="callDiv d-flex justify-content-between mb-3">
    //         <p className="userCallInformation m-0" title="Total Calls">{params.row.TotalCallAttempts}</p>
    //         <p className="userCallInformation m-0" title="Busy/Missed/No Answer">{params.row.MissedCalls}</p>
    //       </div>
    //       <div className="callDiv d-flex justify-content-between callLastDiv">
    //         <p className="userCallInformation m-0" title="Total Duration (min.)">{params.row.LastCallDuration}</p>
    //         <p className="userCallInformation m-0" title="Completed Calls">{params.row.CallReceived}</p>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "PatientFullName",
      headerName: "Client Name",
      width: 140,
      renderCell: (params) => (
        <div>
          <p className="multipleObjCol m-0 mb-1">{params.row.PatientFullName}</p>
          {/* <p className="multipleObjCol m-0 mt-1">{new Date(params.row.PatientDateOfBirth).toLocaleDateString()}</p> */}
        </div>
      ),
    },
    // { field: "PatientEmailAddress", headerName: "Email", width: 190 },
    { field: "PatientContactNumber", headerName: "Client Contact Number", width: 200, },
    {
      field: "ProviderDetails", headerName: "Provider Details", width: 150,
      renderCell: (params) => (
        <div>
          <p className="multipleObjCol m-0 mb-1">{params.row.ProviderName}</p>
          <p className="multipleObjCol m-0 mt-1">{params.row.ProviderFacilityName}</p>
        </div>
      ),
    },
    { field: "Transcript", headerName: "All Transcripts", width: 170, renderCell: (params) => <Tooltip title="View Transcript"> <button className="transcript_button" onClick={() => menuHandle(params.row.Id)} >Click to view transcript</button> </Tooltip> },
    { field: "Summary", headerName: "Summary", width: 160, renderCell: (params) => <Tooltip title="View Summary"> <button className="transcript_button" onClick={() => summaryHandle(params.row.Id)} >Click to view summary</button> </Tooltip> },
    // { field: "menu", headerName: "Menu", width: 80, renderCell: (params) => <Tooltip title="Transcript"> <FontAwesomeIcon icon={faEllipsis} onClick={() => menuHandle(params.row.Id)} /> </Tooltip> },
    // {
    //   field: "Delete", headerName: "Delete", width: 100,
    //   renderCell: (params) => <FontAwesomeIcon icon={faCircleXmark} className={`text-center cursor-pointer`} onClick={() => deleteCallHandle(params.row.Id)} />
    // },
    // {
    //   field: "Call Queue", headerName: "Call Queue", width: 100,
    //   renderCell: (params) => <FontAwesomeIcon icon={faRotateLeft} className={`text-center ${params.row.DoNotCall === true && params.row.Transcript ? "activeTrue" : ""} cursor-pointer`} onClick={() => callQueCallHandle(params.row.Id)} />
    // },
    // {
    //   field: "DoNotCall", headerName: "Do Not Call", width: 100,
    //   renderCell: (params) => <FontAwesomeIcon icon={faPhoneSlash} className={`text-center ${params.row.DoNotCall === true ? "activeFalse" : ""} cursor-pointer`} onClick={() => doNotCallBtnHandle(params.row.Id)} />
    // },
  ];

  const handleCloseModal = () => {
    setModalShow(false);
    setTranscriptRecord("");
  }

  const menuHandle = (id) => {
    setActiveModal("menu");
    setMenuId(id)
    transcriptionsFetchHandle(id, PracticeId);
  }

  const summaryHandle = (id) => {
    setActiveModal("summary");
    setMenuId(id)
    transcriptionsFetchHandle(id, PracticeId);
  }

  const statusHandle = (id) => {
    setActiveModal("status");
    setMenuId(id)
    transcriptionsFetchHandle(id, PracticeId);
  }

  const deleteCallHandle = (id) => {
    setActiveModal("Delete");
    setUserId(id)
    transcriptionsFetchHandle(id, PracticeId);
  }

  const callQueCallHandle = (id) => {
    setUserId(id)
    setModalShow(true)
    setActiveModal("CallQue");
  }

  const doNotCallBtnHandle = (id) => {
    setUserId(id)
    setModalShow(true)
    setActiveModal("DoNotCall");
  }

  async function awareNessCRFetchHandle() {
    if (userType === "admin") {
      setIsData(true);
      setChatGGridData([]);
    }

    let url = `/api/ChatbotLeadGeneration`;
    //let obj = { PracticeId, practiceContactNumber: outBoundContact };
    let obj = { PracticeId };
    const userData = await dateRangeRequest(token, url, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
      setIsData(false);
    }
    else if (userData == "no record") {
      setChatGGridData([]);
      setIsCallsDataGet(true);
      setIsData(false);
    }
    else {
      setChatGGridData(userData);
      setIsCallsDataGet(true);
      setIsData(false);
    }
  }

  const formatter = (date, content) => {
    return (`<b>${date}</b>
<pre>${content}</pre>
\n`)
  }

  async function transcriptionsFetchHandle(menuId, PracticeId) {
    setTranscriptRecord("");
    setStatus("");
    setSummary("");

    let url = "/api/getInOutboundCallsTranscripts";
    let obj = {
      leadId: menuId,
      memberListType: "ChatbotLeadGeneration",
      PracticeId: PracticeId
    }
    const userData = await dateRangeRequest(token, url, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true)
    }
    else if (userData == "no record") {
      setModalShow(true)
    }
    else {
      let transcriptionsText = "";
      let summariesText = "";
      let statusesText = "";

      const groupByDate = Object.groupBy(userData, item =>
        item.CreateDateTime.split("T")[0]
      );

      const reversed = Object.fromEntries(
        Object.entries(groupByDate).reverse()
      );

      for (const key in reversed) {
        let content = "";
        for (const element of groupByDate[key]) {
          content += `${element.Role}: "${element.TranscriptText}"\n`
        }
        const formattedDate = new Date(key).toLocaleDateString("en-US", {
          timeZone: practiceTimezone,
          year: "numeric",
          month: "long",
          day: "numeric"
        })
        transcriptionsText += formatter(formattedDate, content);
      }

      if (transcriptionsText) {
        setTranscriptRecord(transcriptionsText);
        setModalShow(true)
      }
      else {
        setTranscriptRecord("");
      }

      if (summariesText) {
        setSummary(summariesText);
        setModalShow(true)
      }
      else {
        setSummary("");
      }

      if (statusesText) {
        setStatus(statusesText);
        setModalShow(true)
      }
      else {
        setStatus("");
      }
    }
  }

  const closeCallHandle = async (e) => {
    setModalShow(false);
  }

  let doNotCall = false;
  const cancelCallHandle = async (e) => {
    // doNotCall = true;
    let id = userId;
    let obj = { memberListType: "ChatbotLeadGeneration", Id: id, practiceId: PracticeId };

    let url = `/api/deleteLead`;
    const userData = await deleteRequest(token, url, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true)
    }
    else {
      awareNessCRFetchHandle()
      getUserLicenseDetails(usersPostRequest, token, PracticeId, setIsTokenExpired, setOutBoundLeadsDetail);
      setModalShow(false)
    }
  }

  const queueCallHandle = async (e) => {
    setModalShow(false);
  }

  const doNotCallHandle = async (e) => {
    setModalShow(false);
  }

  const getRowId = () => uuidv4();

  async function handleSearchInputChange() {
    let url = `/api/SearchChatbotLeadGeneration`;
    let obj = { patientName, providerName, PracticeId }
    const userData = await usersPostRequest(token, url, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true)
    }
    else {
      setChatGGridData(userData);
    }
  }

  async function handleStartDateChange() {
    let url = "/api/SearchWithDateChatbotG";
    let obj = {
      startDate: startDate,
      endDate: endDate,
      PracticeId: PracticeId
    }
    const userData = await dateRangeRequest(token, url, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true)
    }
    else {
      setChatGGridData(userData);
    }
  }

  const filterTranscriptRecord = () => {
    // if (priorAuthQGridData.length > 0 && menuId != null) {
    let filteredData = chatGGridData.filter((e) => e.Id === menuId);
    setTranscriptRecord(filteredData);
    // }
  }

  const callMakeHandle = async (e) => {
    e.target.disabled = true;

    // let url = 'https://stream-api.underdev.online/make_call';
    let url = `https://fastapi-stream.underdev.online/make_call`;
    // let url = `/api/testingInterval`;
    let obj = {
      "practiceId": PracticeId,
      "startDate": "2024-01-05",
      "memberListType": "ChatbotLeadGeneration",
      "token": token
    }
    await axios.post(url, obj)
      .then(response => {
        if (response.status == '200') {
          setCallAPIMsg(`"${response.data}"`);
        }
        else {
          setCallAPIMsg("'Something went wrong call not be initiated'");
        }
      })
      .catch(error => {
        setCallAPIMsg(`"${error.message} : Something went wrong"`);
      })

    setTimeout(() => {
      setCallAPIMsg("")
    }, 5000);

    e.target.disabled = false;
  }

  // useEffect(() => {
  //   if (menuId != null) {
  //     filterTranscriptRecord()
  //   }
  // }, [menuId])

  // Token-expiry redirect is now handled once, centrally, in ContextApi.js - see its comment
  // for why this component's own copy of the same effect was removed.

  useEffect(() => {
    if (providerName || patientName) {
      setSideBarLinkActive("careConsole");
      handleSearchInputChange();
    } else {
      awareNessCRFetchHandle()
    }
  }, [providerName, patientName])

  // useEffect(() => {
  //   if (startDate || endDate) {
  //     setSideBarLinkActive("careConsole")
  //     handleStartDateChange();
  //   } else {
  //     awareNessCRFetchHandle()
  //   }
  // }, [startDate, endDate])

  useEffect(() => {
    if (PracticeId && token || isUploadLead === true) {
      awareNessCRFetchHandle();
      setIsUploadLead(false);
    }
  }, [PracticeId, token, isUploadLead])

  //Add Export Button Functionality

  const apiRef = useGridApiRef();

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      fileName: 'ChatbotLeadGenerationData',
      fields: ['CreateDateTime', 'PatientFullName', 'PatientContactNumber', 'ProviderName', 'Transcript']
    });
  };

  return (
    <>
      <div className="col-lg-12 position-relative">
        <div className="grid-layout">
          <DataGrid
            apiRef={apiRef}
            rows={chatGGridData ? chatGGridData : []}
            rowHeight={82}
            columns={columns}
            autoWidth
            pageSize={12}
            pageSizeOptions={[10, 25, 50, 100]}
            loading={userType === "admin" && isData === true}
            getRowId={getRowId}
            // disableColumnSorting
            disableColumnMenu
          />
          <button
            onClick={handleExport}
            className="export-btn"
          >
            <FontAwesomeIcon icon={faFileExport} /> Export to CSV
          </button>
        </div>
        {/* <button onClick={callMakeHandle} className="simple-btn position-absolute start-0 bottom-0 mb-2 ms-4 px-5"><FontAwesomeIcon className="me-2" icon={faPhone} />Make a call</button>
        {
          callAPIMsg &&
          (<div className="position-absolute callAPIMsg start-0 bottom-0 mb-2 ms-5 px-5">{callAPIMsg}</div>)
        } */}
      </div>
      <Modal className="popup" show={modalShow} onHide={() => setModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {activeModal === "menu" ? "Transcripts"
              : activeModal === "summary" ? "Summary"
                : activeModal === "status" ? "Status"
                  : activeModal === "DoNotCall" ? "Do Not Call"
                    : activeModal === "Delete" ? "Delete Record"
                      : "Queue Call"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activeModal === "menu" ?
            <p> {transcriptRecord ?
              (
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(transcriptRecord) }} />
              )
              // transcriptsDetail.map((record) => {
              //   <>
              //     <b>{record.CreatedDateTime}</b>
              //     <pre>{record.TranscriptText}</pre>
              //     <hr/>
              //   </>
              // }) 
              : ""} </p> :
            activeModal === "summary" ?
              <p> {summary ?
                (
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }} />
                )

                : ""} </p> :
              activeModal === "status" ?
                <p> {status ?
                  (
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(status) }} />
                  )

                  : ""} </p> :
                activeModal === "DoNotCall" ?
                  <p>Are you sure that you don't want to call this lead</p>
                  :
                  activeModal == "Delete" && transcriptRecord ?
                    <p>You can't delete this lead as it has been already processed</p>
                    :
                    activeModal == "Delete" ?
                      <p>Are you sure that you don't want to process call on this lead</p>
                      :
                      <p>Are you sure that you want to requeue call on this lead again</p>
          }
        </Modal.Body>
        <Modal.Footer>
          {
            activeModal === "menu" || activeModal === "summary" || activeModal === "status" ?
              <button className="simple-btn" onClick={handleCloseModal}>Close</button>
              :
              activeModal === "Delete" && transcriptRecord ?
                <button className="simple-btn me-2" id="closeTrue" onClick={closeCallHandle}>Close</button>
                :
                activeModal === "DoNotCall" ?
                  <>
                    <button className="simple-btn me-2" id="closeTrue" onClick={queueCallHandle}>No</button>
                    <button className="simple-btn" id="updateTrue" onClick={doNotCallHandle}>Yes</button>
                  </>
                  :
                  activeModal === "Delete" ?
                    <>
                      <button className="simple-btn me-2" id="closeTrue" onClick={closeCallHandle}>No</button>
                      <button className="simple-btn" id="updateTrue" onClick={cancelCallHandle}>Yes</button>
                    </>
                    :
                    <>
                      <button className="simple-btn me-2" id="closeTrue" onClick={closeCallHandle}>No</button>
                      <button className="simple-btn" id="updateTrue" onClick={queueCallHandle}>Yes</button>
                    </>
          }
        </Modal.Footer>
      </Modal>
    </>
  );
};


